import { firebaseDb } from '../services/firebase'
import { Collection } from '../config/enums'
import { ItemCard, itemConverter } from '../models/Item'
import { Image } from '../models/Item'
import { getFeaturedPhoto } from '../utility/imageUtils'

export type ItemChangeHandler = (items: ItemCard[]) => void

export default class VendorListingRepo {
  private onItemChange: ItemChangeHandler
  private vendorId: string
  private limitSearch: number
  private searchText: string = ''
  private unsubscribe: (() => void) | null = null

  constructor(
    vendorId: string,
    limitSearch: number,
    onChange: ItemChangeHandler
  ) {
    this.vendorId = vendorId
    this.limitSearch = limitSearch
    this.onItemChange = onChange
    this.listenForAllItems()
  }

  private listenForAllItems() {
    console.log(`listenForAllItems called!`)
    this.unsubscribe = firebaseDb
      .collection(Collection.items)
      .where('vendorId', '==', this.vendorId)
      .limit(this.limitSearch)
      .orderBy('createdAt', 'desc')
      .withConverter(itemConverter)
      .onSnapshot(snap => {
        let docs: ItemCard[] = []
        snap.forEach(doc => {
          docs.push({
            itemId: doc!.id,
            imageSrc:
              getFeaturedPhoto(doc?.data().images as Image[]) || '/image.png',
            itemTitle: doc!.data().title,
            itemDesc: doc!.data().description,
            itemButton: 'Edit',
            itemButtonUrl: '/vendor/editlisting/' + doc!.id,
            itemActive: doc.data().isActive,
            itemPrice: doc.data().variants[0].price
          })
        })
        this.onItemChange(docs)
      })
  }

  private listenForFilteredItems() {
    console.log(`listenForFilteredItems called!`)
    this.unsubscribe = firebaseDb
      .collection(Collection.items)
      .where('vendorId', '==', this.vendorId)
      .where('keywords', 'array-contains', this.searchText.toLowerCase())
      .limit(this.limitSearch)
      .orderBy('createdAt', 'desc')
      .withConverter(itemConverter)
      .onSnapshot(snap => {
        let docs: ItemCard[] = []
        snap.forEach(doc => {
          docs.push({
            itemId: doc!.id,
            imageSrc:
              getFeaturedPhoto(doc?.data().images as Image[]) || '/image.png',
            itemTitle: doc!.data().title,
            itemDesc: doc!.data().description,
            itemButton: 'Edit',
            itemButtonUrl: '/vendor/editlisting/' + doc!.id,
            itemActive: doc.data().isActive,
            itemPrice: doc.data().variants[0].price
          })
        })
        this.onItemChange(docs)
      })
  }

  setSearchTextAndLimit(searchText: string, limitSearch: number) {
    this.searchText = searchText
    this.limitSearch = limitSearch
    this.stopListening()

    if (searchText.length) {
      this.listenForFilteredItems()
    } else {
      this.listenForAllItems()
    }
  }

  stopListening() {
    if (this.unsubscribe) {
      this.unsubscribe()
    }
  }
}
